import * as React from 'react';

export type FallbackType = NonNullable<React.ReactNode> | null;

export interface FallbackContextType {
  updateFallback: (fallback: FallbackType) => void;
}

export const FallbackContext = React.createContext<FallbackContextType>({
  updateFallback: () => {},
});

export const FallbackProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [fallback, setFallback] = React.useState<FallbackType>(null);

  const updateFallback = React.useCallback((newFallback: FallbackType) => {
    setFallback(() => newFallback);
  }, []);

  const renderChildren = React.useMemo(() => children, [children]);

  return (
    <FallbackContext.Provider value={{ updateFallback }}>
      <React.Suspense fallback={fallback}>{renderChildren}</React.Suspense>
    </FallbackContext.Provider>
  );
};
